export const Colors = {
  // BRAND PALETTE -- picpopstudio.com. Keep in sync with the SCSS palette in index.scss (a test checks it).
  // Black and green only. Lime is the primary FILL and always carries ink text (onPrimary); lime is too light to
  // be text, so accent text is ink. limeTint is the pale green for selected states and the tertiary button.
  ink: "#1D1D1D",
  raised: "#2A2A28",
  cream: "#F7F3E9",
  lime: "#A5DA05",
  limeTint: "#EDF7CF",
  line: "#E4DED0",
  muted: "#5C574E",
  mutedOnDark: "#C9C3B6",
  onPrimary: "#1D1D1D",
  primaryColor: "#A5DA05",
  colorTertiary: "#EDF7CF",
  primaryBtnColor: "#A5DA05",
  primaryTextColor: "#1D1D1D",
  secondaryBtnColor: "#F7F3E9",
  primaryGradient: "linear-gradient(94deg, #A5DA05 0%, #A5DA05 100%)",
  secondaryColor:"#111827",
  primaryWhite:"#F8FAFC",
  fontPrimary: "#1D1D1D",
  fontSecondary: "#5C574E",
  placeholder: "#D1D5DB",
  googleColor:"#18191C",
  buttonBackgroundInActive:"#F1F1F1",
  dropDownItemColor:"#9094A2",
  dropDownItemColorSelected:"#5D616F",
  sliderBackground:"#E2E8F0",
  buttonBorder: "#E4DED0",
  border: "#E4DED0",
  buttonOutlineText:"#585858",
  black: "#000000",
  white: "#FFFFFF",
  gray: "#374151",
  transparent: "transparent",
  error: "#DC2626",
  lightGray: "#E5E7EB",
  opacityGray: "rgba(0, 0, 0, 0.3)",
  tabsListBackground: "#F7F3E9",
  tabsListBorder: "#C8CAD0",
  screenBackground: "#FFFFFF",
  paidBackground:"#D2FFE2",
  paidBorder:"#90E2AC",
  paidText:"#00571B",
  pendingBackground:"#FFF8C3",
  pendingBorder:"#FFD983",
  pendingText:"#CAA501",
  propertiesBackground: "#F7F3E9",
  editorBackground: "#FFFFFF",
  // The work area of the editor (its WebGL canvas): a colour of its own, so it stands out from the white around it.
  canvasBackground: "#E4DED0",
  toastSuccessBackground:"#F0FFF4",
  toastSuccessText:"#28A745",
  toastErrorBackground:"#FFF1F0",
  toastErrorText:"#F44336",
  transformBoxColor:0xA5DA05,
};
